import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import InfoIcon from "assets/svg/info_small.svg";

import { numberFormatter } from "helpers/number-formatter";

import SwiperWrapper from "components/swiper-wrapper";

import styles from "./styles.module.css";

const DemographicQuickInfo = ({ districtReportDemographicInfos }) => {
  const {
    averageAge,
    educationalLevelDensity,
    houseIncomeTotal,
    maritalStatusDensity,
    socioeconomicStatusDensity,
    totalPopulation,
    totalPopulationDensity,
  } = districtReportDemographicInfos || {};

  const houseIncomeTotalPrice = numberFormatter(houseIncomeTotal) ? `${numberFormatter(houseIncomeTotal)} TL` : "-";

  const demographicInfos = [
    {
      title: "Toplam Nüfus",
      description: `${numberFormatter(totalPopulation) || "-"} - ${totalPopulationDensity || "-"}`,
    },
    { title: "Eğitim Durumu", description: educationalLevelDensity },
    { title: "Ortalama Yaş", description: averageAge },
    { title: "Medeni Hal", description: maritalStatusDensity },
    { title: "Sosyo-Ekonomik Statü", description: socioeconomicStatusDensity },
    { title: "Hane Halkı Geliri", description: houseIncomeTotalPrice },
  ];
  return (
    <div className={styles.infoWrapper}>
      <SwiperWrapper>
        <Swiper navigation={true} loop={false} modules={[Navigation]} slidesPerView="auto">
          {demographicInfos?.map((info, index) => (
            <SwiperSlide key={index}>
              <div className={styles.infoFlex}>
                {index !== 0 && <div className={styles.borderBetweenItems} />}
                <div className={styles.infoItem}>
                  {info.title === "Hane Halkı Geliri" ? (
                    <div className={styles.infoTitleWrapper}>
                      <span className={styles.infoTitle}>{info.title}</span>

                      <div
                        /* eslint-disable-next-line */
                        tooltip="Hane geliri, bulunduğunuz mahalle için ortalama geçim tutarını tahmin etmenize yardımcı olabilir."
                        /* eslint-disable-next-line */
                        flow="left"
                        className={styles.infoIcon}
                      >
                        <InfoIcon />
                      </div>
                    </div>
                  ) : (
                    <span className={styles.infoTitle}>{info.title}</span>
                  )}
                  <p className={styles.infoDescription}>{info.description || "-"}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </SwiperWrapper>
    </div>
  );
};

DemographicQuickInfo.propTypes = {
  districtReportDemographicInfos: PropTypes.object,
};

export default DemographicQuickInfo;
